export { default as CubeSolidIcon } from './CubeSolidIcon';
